var map = {
	"./ASP.png": "d72a",
	"./angular.png": "a5bf",
	"./aws.png": "0f8a",
	"./c#.png": "99dd",
	"./django.png": "fcc6",
	"./docker.png": "58fc",
	"./flask.png": "c185",
	"./flutter.png": "ab21",
	"./git.png": "5998",
	"./go.png": "8211",
	"./graphql.png": "6b44",
	"./gridsome.png": "bb33",
	"./html.png": "e919",
	"./java.png": "fd8c",
	"./jenkins.png": "e72a",
	"./kubernetes.png": "0a28",
	"./laravel.png": "d30d",
	"./mongodb.png": "cac8",
	"./mysql.png": "b539",
	"./next.png": "386b",
	"./nodejs.png": "22a9",
	"./nuxt.png": "0036",
	"./php.png": "d2af",
	"./python.png": "b1b6",
	"./react-native.png": "9afd",
	"./react.png": "9b8c",
	"./ruby.png": "3ca5",
	"./svelte.png": "3c8c",
	"./swift.png": "7e37",
	"./vue.png": "c116",
	"./wordpress.png": "5940"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "018c";